/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Anchor scroll functionality for links with data-scroll-to attribute
  document.addEventListener('DOMContentLoaded', function() {
    const scrollToLinks = document.querySelectorAll('[data-scroll-to]');
    
    scrollToLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        const anchorId = this.getAttribute('data-scroll-to');
        const targetElement = document.getElementById(anchorId);
        
        if (targetElement) {
          e.preventDefault();
          
          // Calculate offset (accounting for sticky header if present)
          const headerHeight = document.querySelector('[data-header-sticky]') 
            ? document.querySelector('[data-header-height]').offsetHeight 
            : 0;
          
          const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
          
          // Smooth scroll to target
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });

          // Update URL hash
          history.pushState(null, '', '#' + anchorId);
        }
      });
    });
  });

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
